import { useRef, useState, useEffect } from 'react'
import BannerBlock from './BannerBlock/BannerBlock'
import AddressBlock from './AddressBlock/AddressBlock'
import FeedbackFormBlock from './FeedbackFormBlock/FeedbackFormBlock'
import MapBlock from './MapBlock/MapBlock'
import SocialBlock from './SocialBlock/SocialBlock'
import style from './contactspage.module.scss'
import { fetchFacilities } from '../../services/api'

const ContactsPage = () => {
    const mapBlockRef = useRef(null)
    const [selectedLocation, setSelectedLocation] = useState(null)
    const [branches, setBranches] = useState([])
    const [loading, setLoading] = useState(true)

    // Функция для получения координат филиала (дублируем для consistency)
    const getBranchCoordinates = (branch) => {
        if (branch.attributes.coordinates) {
            return branch.attributes.coordinates;
        }
        if (branch.attributes.MapY && branch.attributes.MapX) {
            return [branch.attributes.MapY, branch.attributes.MapX];
        }
        return null;
    };

    useEffect(() => {
        const loadBranches = async () => {
            setLoading(true)
            try {
                const { data } = await fetchFacilities()
                setBranches(data)
                
                // Отладочная информация
                console.log('Loaded branches:', data);
                data.forEach((branch, index) => {
                    console.log(`Branch ${index}:`, branch.attributes.Title);
                    console.log('  - coordinates:', branch.attributes.coordinates);
                    console.log('  - MapX:', branch.attributes.MapX);
                    console.log('  - MapY:', branch.attributes.MapY);
                });

                // Устанавливаем координаты первого филиала как начальные
                if (data.length > 0) {
                    const firstBranchCoords = getBranchCoordinates(data[0]);
                    if (firstBranchCoords) {
                        setSelectedLocation(firstBranchCoords);
                        console.log('Set initial location to:', firstBranchCoords);
                    } else {
                        // Fallback координаты
                        setSelectedLocation([45.0355, 38.9750]);
                        console.log('Using fallback location');
                    }
                }
            } catch (error) {
                console.error('Failed to load branches:', error)
            } finally {
                setLoading(false)
            }
        }

        loadBranches()
    }, [])

    const handleShowOnMap = (coordinates) => {
        console.log('Show on map clicked, coordinates:', coordinates);
        if (coordinates && Array.isArray(coordinates) && coordinates.length === 2) {
            setSelectedLocation(coordinates)
        } else {
            console.warn('Invalid coordinates received:', coordinates);
        }
        if (mapBlockRef.current) {
            mapBlockRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            })
        }
    }

    return (
        <div className={style.contactspage}>
            <div className={style.pageContainer}>
                <BannerBlock />
                <AddressBlock 
                    onShowOnMap={handleShowOnMap} 
                    branches={branches}
                    loading={loading}
                />
                <FeedbackFormBlock />
                <MapBlock 
                    ref={mapBlockRef} 
                    center={selectedLocation}
                    branches={branches}
                    loading={loading}
                />
                <SocialBlock />
            </div>
        </div>
    )
}

export default ContactsPage